import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-search\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"currentColor\" d=\"m11.117 10.056 3.535 3.535-1.06 1.061-3.536-3.535z\" /><circle cx=\"7\" cy=\"7\" r=\"5.25\" stroke=\"currentColor\" stroke-width=\"1.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol